import Spacer from "@components/Spacer";
import { CreateAccount } from "@features/auth/create-account-screen";
import LoginOrSignupSmallScreen, { Advantages, DevelopmentSignUp } from "@features/auth/login-or-signup-small-screen";
import { Login } from "@features/auth/login-screen";
import ScreenScrollView from "@features/scroll-view/screen-scroll-view";
import useCustomWindowDimensions from "@hooks/use-custom-window-dimensions";
import { Container, H2, View } from "dripsy";
import * as React from "react";
import { useStoryBlokStory } from "@provider/storyblok-provider";
import type { AuthStoryblok } from "@type/storyblock-types.d.ts";

function LoginOrSignupScreen() {
  const { width } = useCustomWindowDimensions();
  const isLarge = width > 800;

  const content = useStoryBlokStory<AuthStoryblok>("account");

  if (!isLarge) {
    return <LoginOrSignupSmallScreen />;
  }
  return (
    <>
      <ScreenScrollView
        avoidKeyboard
        sx={{
          backgroundColor: "$secondaryBackground",
        }}
      >
        <Container
          sx={{
            flexDirection: "row",
            gap: 56,
            mt: "$10",
          }}
        >
          <View sx={{ flex: 1 }}>
            <H2 sx={{ fontWeight: "600" }}>Inloggen</H2>
            <Login />
          </View>
          <View sx={{ flex: 1 }}>
            <H2 sx={{ fontWeight: "600" }}>Nieuwe klant</H2>
            <CreateAccount />
            <Spacer size="$3" />
            <Advantages usp1={content.usp_1} usp2={content.usp_2} usp3={content.usp_3} usp4={content.usp_4} />
            <DevelopmentSignUp />
          </View>
        </Container>
      </ScreenScrollView>
    </>
  );
}
export default LoginOrSignupScreen;
